




































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import PrecificacaoModel from "@/models/cadastros/saude/PrecificacaoModel";
import { PaginationModel } from "@/models/commons/PaginationModel";
import PrecificacaoFiltro from "@/models/cadastros/saude/PrecificacaoFiltro";
import { saudePrecificacaoService } from "@/service/cadastro/saude/precificacao/SaudePrecificacaoService";
import { saudeCidadeService } from "@/service/cadastro/saude/cidade/SaudeCidadeService";
import { saudeEspecialidadeService } from "@/service/cadastro/saude/especialidade/SaudeEspecialidadeService";
import MessageDialog from "@/components/modal/MessageDialog.vue";
import { estadosList, EstadoModel } from "@/models/commons/EstadoModel";
import EspecialidadeAutocomplete from "@/components/saude/EspecialidadeAutocomplete.vue";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";

@Component({
  components: {
    GsModalDialog,
    EspecialidadeAutocomplete,
  },
})
export default class ListaPrecificacoes extends Vue {

  options: PaginationModel = {
    itemsPerPage: 5,
    page: 1,
    itemsLength: 0,
  };
  cabecalho = [
    { text: "Especialidade", value: "nomeEspecialidade", width: "20%" },
    { text: "Valor", value: "precoAssociado", width: "20%" },
    { text: "Cidade", value: "nomeCidade", width: "20%" },
    { text: "Ações", value: "actions", sortable: false, width: "20%" },
  ];

  cidades: [] = [];
  estados = estadosList;
  especialidades: [] = [];
  precos: [] = [];
  preco: PrecificacaoModel = {};
  loading = false;


  dialogType = "";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";

  filtro: PrecificacaoFiltro = this.limparFiltro();

  precoExclusao: PrecificacaoModel = {};

  mounted() {
    saudeEspecialidadeService.pesquisar().then((res: any) => {
      this.especialidades = res.content;
    });
  }

  @Watch("filtro.estado")
  estadoHandle() {
    saudeCidadeService
      .obterCidadesPorEstado(this.filtro.estado?.sigla)
      .then((res: any) => {
        this.cidades = res;
      });
  }

  limparFiltro() {
    return {
      cidade: undefined,
      especialidade: undefined,
      estado: undefined,
    };
  }

  filtrar() {
    if(this.options.page == 1) {
      this.obterDados();
    } else {
      this.options.page = 1;
    }
  }

  obterDados() {
    this.loading = true;
    saudePrecificacaoService
      .pesquisar(this.filtro, this.options)
      .then((res: any) => {
        this.precos = res.content;
        this.options.itemsLength = res.totalElements;
        this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
      });
  }

  @Watch("options.page")
  handlePagination() {
    this.obterDados();
  }

  
  @Watch("options.itemsLength")
  handlePageSize() {
    if(this.options.page == 1) {
      this.obterDados();
    } else {
      this.options.page = 1;
    }
  }


  excluirPreco(preco: any) {
    this.precoExclusao = preco;
    console.log(preco);
    this.openDialog('confirm', 'Confimação de exclusão', `Deseja realmente excluir o preço da cidade ${preco.nomeCidade} e especialidade ${preco.nomeEspecialidade}?`);
  }

  excluir() {
    if (this.precoExclusao?.id) {
      saudePrecificacaoService.deletar(this.precoExclusao?.id).then(
        (res) => {
          this.openDialog('success', 'Sucesso', 'Excluído com sucesso.');
          this.filtrar();
        },
        (err) => {
          this.openDialog('error', 'Erro', err);
        }
      );
    }
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
      case "confirm":
        color = "error";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }
}
